module.exports = __webpack_public_path__ + "static/img/2.dd455c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/2.png
// module id = LWOq
// module chunks = 0